import { selectNoScopeValidationScope, selectReadOnly } from '../../../util/useSelectorFunctions';
import { VCycleElementDecoratorContent } from './VCycleElementDecoratorContent';
import { useSelector } from 'react-redux';
import React from 'react';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import {
    defaultVCycleElementDecoratorResource,
    useVCycleElementDecoratorActions,
    VCycleElementDecoratorMutationResourceSchema,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementDecoratorResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';

export const VCycleElementDecoratorEditDialog= ({ onClose, objectId, versionedInId }: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const vCycleElementDecoratorActions = useVCycleElementDecoratorActions()
    const vCycleElementDecoratorQuery = vCycleElementDecoratorActions.useGetResourceByObjectIdAndVersionedIn(
        objectId,
        versionedInId
    );
    const updateVCycleElementDecorator = vCycleElementDecoratorActions.useUpdateResource();
    const validation = vCycleElementDecoratorActions.useValidateResource(
        vCycleElementDecoratorQuery.data?.id,
        validationScope
    );

    const { form, formNames, onSubmit } = useMyForm({
        schema: VCycleElementDecoratorMutationResourceSchema,
        defaultValues: defaultVCycleElementDecoratorResource,
        submitHandler: async (data) => {
            await updateVCycleElementDecorator.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: vCycleElementDecoratorQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit V-Cycle Element Decorator'}
            resourceType={ResourceType.V_CYCLE_ELEMENT_DECORATOR}
            resourceValidationResult={validation.data}
            metaDataInfo={vCycleElementDecoratorQuery.data}
        >
            <QueryBaseComponent name="VCycleElementDecorator" query={vCycleElementDecoratorQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <VCycleElementDecoratorContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={vCycleElementDecoratorQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
